
import { Component, Vue } from 'vue-property-decorator'
import AppBox from '@/components/AppBox.vue'
import AppButtonOutline from '@/components/AppButtonOutline.vue'
import AppButton from '@/components/AppButton.vue'
import AppInput from '@/components/AppInput.vue'
import { ChildComponentMixin } from '@/mixins'
import { toCSV } from '@/utils/csv'

@Component({
    components: {
        AppBox,
        AppButton,
        AppButtonOutline,
        AppInput,
    },
})
export default class QueryBox extends ChildComponentMixin {
    public query: string = ''
    public name: string = ''
    public description: string = ''
    public expandedSaveQuery: boolean = false

    get hasError() {
        return this.$store.state.query.error.length > 0
    }

    get error() {
        return this.$store.state.query.error
    }

    public search() {
        this.$store.dispatch('query/execute', this.query)
    }

    public downloadCSV() {
        const csv = toCSV(this.$store.state.query.result)

        const link = document.createElement('a')
        link.setAttribute('download', 'result.csv')
        link.setAttribute('href', 'data:text/text;charset=utf-8,' + encodeURI(csv))
        link.click()
    }

    public expandSaveQuery() {
        this.expandedSaveQuery = true
    }
    public saveQuery() {
        this.$store.dispatch('query/saveQuery', {
            name: this.name,
            description: this.description,
            query: this.query,
        })
        this.colapseSaveQuery()
    }
    public colapseSaveQuery() {
        this.name = ''
        this.description = ''
        this.expandedSaveQuery = false
    }
}
